import axios from 'axios';
import lineChart from '@/components/charts/lineChart.vue';
import Loader from '@/components/Loader/Loader.vue';
import dualAxisChart from '@/components/charts/dualAxisChart.vue'
import funnelChart from '@/components/charts/funnelChart.vue';
export default {
    name: 'PurchaseJourney',
    components: {
        Loader, lineChart,dualAxisChart,funnelChart
    },
    data() {
        return {
            loader: false,
            dateRange: {
                startDate: moment().subtract(4, 'week').format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
            },
           viewFirstPurchaseJourneyData:'',
           viewSecondPurchaseJourneyData:'',
           isTableSubHeading:false,
           firstPurchaseGraphData:{},
           secondPurchaseGraphData:{},
           firstFunnelGraphData:[
                {
                    name: 'Active users',
                    data: []
                }
           ],
           secondFunnelGraphData:[
                {
                    name: 'Active users',
                    data: []
                }
           ],
           firstFunnelLoader: false,
           secondFunnelLoader: false,
        }
    },

    created() {
        // this.initializeModal();
        this.dataAPIs();
    },
   
    methods: {
        dataAPIs(){
            $("#reports_table_first").DataTable().destroy();
            $("#reports_table_second").DataTable().destroy();

            this.getFirstPurchaseJourneyData();
            this.getSecondPurchaseJourneyData();

        },

        formatNumber(num) {
            if(num == '') { return }
            if (isNaN(num)) { return num }
            let num1 = Number(num).toFixed(2);
            let num2 = Number(num1).toLocaleString();
            return num2
        },

        getFirstPurchaseJourneyData() {
            this.viewFirstPurchaseJourneyData = {}
            this.firstPurchaseGraphData='',
            this.firstFunnelGraphData = '',
            this.firstFunnelLoader = true
            this.loader = true
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                journey_type: "journey1"
            }
            const url = "/api/v1/analytics/purchasejourney"
            axios.post(url, payload).then(res => {
                this.viewFirstPurchaseJourneyData = res.data
                this.$nextTick(() => {
                    this.processTable('#reports_table_first')
                })
                this.firstPurchaseGraphData = this.processPurchaseJourneyGraph(res.data);
                this.firstFunnelGraphData = this.proccessFunnelChartData(res?.data?.funnel_data,'Active users');
                this.loader = false
                this.firstFunnelLoader = false
            }).catch((err) => {
                console.log("Err Plugin PlayAccountsData")
                this.loader = false
                this.firstFunnelLoader = false
            })
        },

        getSecondPurchaseJourneyData() {
            this.viewSecondPurchaseJourneyData = {}
            this.secondPurchaseGraphData = '',
            this.secondFunnelGraphData = '',
            this.secondFunnelLoader = true
            this.loader = true
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                journey_type: "journey2"
            }
            const url = "/api/v1/analytics/purchasejourney"
            axios.post(url, payload).then(res => {
                this.viewSecondPurchaseJourneyData = res.data
                this.$nextTick(() => {
                    this.processTable('#reports_table_second')
                })
                this.secondPurchaseGraphData = this.processPurchaseJourneyGraph(res.data);
                this.secondFunnelGraphData = this.proccessFunnelChartData(res?.data?.funnel_data,'Active users');
                this.loader = false
                this.secondFunnelLoader = false
            }).catch((err) => {
                console.log("Err Plugin PlayAccountsData")
                this.loader = false
                this.secondFunnelLoader = false
            })
        },

        processPurchaseJourneyGraph(data){
            let temp ={
                xAxis: data.funnel_data.map(data=>data.funnelStepName),
                disableYLabel: false,
                seriesData:[{
                    name: 'Active users',
                    data: data.funnel_data.map(data=>data.activeUsers)
                }]
            }
            return temp;
        },

        proccessFunnelChartData(data,name) {
            let height={
                0: 41,
                1: 22,
                2: 15.35,
                3: 9.96,
                4: 4.98,
                5: 3.33,
                6: 2.13,
                7: 1.25
            }
            let seriesData = [{
                name: name,
                data: data.map((d,idx) => {return {y:height[idx], name: d.funnelStepName, value:d.activeUsers}})
            }];
            return seriesData;
        },

        processTable(id) {
            $(id).DataTable().destroy();
            var search = require("@/assets/Icons_SVG/Search.svg");
            $(id).DataTable({
                searching: true,
                info: false,
                scrollCollapse: true,
                lengthChange: true,
                ordering: false,
                // sorting: [[sortCol, "asc"]],
                initComplete: function (settings, json) {
                    $('.dataTables_scrollBody tfoot tr').css({ visibility: 'collapse' });
                    $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
                    $(id).wrap("<div style='overflow:auto; width:100%;position:relative;'></div>");
                },
                language: {
                    search: "", searchPlaceholder: "Search...", paginate: {
                        first: "",
                        previous: "<",
                        next: ">",
                        last: "",
                    },
                    lengthMenu: "<h5>Show entries</h5> _MENU_"
                },
            })
            $(id + "_filter > label").append(
                `<div class='search_icon'><img src='${search}' /></div>`
            );
            $(id + ' thead th:first-child').removeClass('sorting sorting_asc sorting_desc');
        },
    },
}